// Util for generic actions dealing with accl microservices
import { S25Util } from "../../util/s25-util";
import { S25WsMicroService } from "./S25WsMicroService";
import ContentWrapper = S25WsMicroService.ContentWrapper;
import { S25Const } from "../../util/s25-const";
import { S25WsMicroOrganization } from "./S25WsMicroOrganization";

export class MicroUtil {
    public static wrapPayloadItem<T>(item: T): ContentWrapper<T> {
        return {
            content: {
                apiVersion: "0.1",
                data: {
                    items: [item],
                },
            },
        };
    }

    public static getMicroItem<T>(wrapper: ContentWrapper<T>) {
        return this.getMicroItems(wrapper)[0];
    }

    public static getMicroItems<T>(wrapper: ContentWrapper<T>) {
        return S25Util.array.forceArray(wrapper?.content?.data?.items);
    }

    public static getContactDetails(contactId: number, contacts: S25WsMicroOrganization.ExpandedInfoContact[]) {
        const contact = S25Util.array.forceArray(contacts).find((c) => c.contactId === contactId);

        if (!contact) {
            return {
                contactId: contactId,
                fullName: S25Const.private,
                firstName: "",
                familyName: S25Const.private,
                email: "",
                isFavorite: false,
            };
        }

        return {
            contactId: contactId,
            fullName: `${contact.firstName || ""} ${contact.familyName || ""}`.trim() ?? S25Const.private,
            firstName: contact.firstName || "",
            familyName: contact.familyName || "",
            email: contact.email || "",
            isFavorite: contact.isFavorite || false,
        };
    }
}
